export enum EndpointsStatusesTokenizeQueryKeys {
  StatusTokenize = '/tokenization-info-receipt',
}

export enum StatusTokenizeQueryKeys {
  StatusTokenize = 'status-tokenize',
}
